import { createAction, props } from '@ngrx/store';
import { Type, CourseContent, StructureMap, CourseStructureNode } from './course.model';


export const setCourseType = createAction(
  '[Course] Set Type',
  props<{ courseType: Type }>()
);


export const addCourseContent = createAction(
  '[Course] Add Course Content',
  props<{ content: CourseContent }>()
);

export const updateCourseContent = createAction(
  '[Course] Update Course Content',
  props<{ content: Partial<CourseContent> }>()
);

// structure
export const loadStructure = createAction(
  '[Structure] Load Structure',
  props<{ course_id: number }>()
);
export const loadStructureSuccess = createAction(
  '[Structure] Load Structure Success',
  props<{ structure: CourseStructureNode[], course_id: number }>()
);

export const loadDetails = createAction(
  '[Structure] Load Details',
  props<{ data: any }>()
);



export const resetCourseData = createAction('[Course] Reset Course Data');

